import React, { useContext, useEffect, useState } from 'react'
import Disqus from 'disqus-react'
import './reviews.scss'
import { I18nContext } from '../../i18n'

const Reviews = ({ article }) => {
  const disqusShortName = 'webtop-blog'
  const { langCode } = useContext(I18nContext)
  const [country, setCountry] = useState('')

  useEffect(() => {
    langCode === 'en' && setCountry('en')
    langCode === 'es' && setCountry('es_ES')
    langCode === 'fr' && setCountry('fr')
  }, [langCode])

  const disqusConfig = {
    url: `https://staging.webtop.blog/${article?.slug}`,
    identifier: String(article?.id),
    title: article?.title?.rendered,
    language: country,
  }

  return (
    <div className="reviews">
      <Disqus.DiscussionEmbed
        shortname={disqusShortName}
        config={disqusConfig}
      />
    </div>
  )
}

export default Reviews
